import React from "react";
import { Line } from "react-chartjs-2";

import { hexToRgb } from "../utils/common";

export default ({ fill = true, width = 100, height = 65, data = null }) => {
	const staticOptions = {
		lineTension: 0.1,
		borderWidth: 2,
		borderCapStyle: "butt",
		borderDash: [],
		borderDashOffset: 0.0,
		borderJoinStyle: "miter",
		pointBackgroundColor: "#fff",
		pointBorderWidth: 1,
		pointHoverRadius: 5,
		pointRadius: 1,
		pointHitRadius: 10,
		cubicInterpolationMode: "monotone"
	};

	const labels = data && data.data_categories ? data.data_categories : ["2019-08-20", "2019-08-21", "2019-08-22"];
	const datasets =
		data && data.data_series
			? data.data_series.map((item) => {
				return {
					label: item.name,
					backgroundColor: `rgba(${hexToRgb(item.color)},0.2)`,
					borderColor: item.color,
					pointBorderColor: item.color,
					data: item.data.map((dataItem) => dataItem.y),
					fill,
					...staticOptions
				};
			})
			: [
				{
					label: "Aerobics - High Impact",
					backgroundColor: `rgba(${hexToRgb("#c850a0")},0.2)`,
					borderColor: "#c850a0",
					pointBorderColor: "#c850a0",
					data: [9, 53, 0],
					...staticOptions
				}
			];
	const chartData = {
		labels,
		datasets
	};

	return <Line data={chartData} legend={null} width={width} height={height} />;
};
